<template>
  <div class="orderinfo-container">
    <img :src="orderInfo.icon" class="orderinfo-pic"/>
    <div class="orderinfo-content">
      <div class="first-floor">
        <span class="order-title">{{orderInfo.title}}</span>
        <span class="order-status">{{orderInfo.orderStatusName}}</span>
      </div>
      <div class="second-floor">
        <span>{{createTime}}</span>
        <div v-if="orderPrice !== ''" class="price">
          <span>{{ orderPrice }}元</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderInfo',
  props: {
    orderInfo: {
      type: Object
    }
  },
  computed: {
    orderPrice() {
      return this.orderInfo.orderPrice ? Number(this.orderInfo.orderPrice) / 100 : ''
    },
    createTime() {
      return this.orderInfo.createTime
        ? new Date(Number(this.orderInfo.createTime)).format('YYYY-MM-DD')
        : ''
    }
  }
}

</script>
<style lang="less" scoped>
  @import 'index.less';
</style>